.popover {
	display: flex;
	flex-direction: column;
	min-height: 0;
	gap: var(--size-5);
	padding: var(--size-4);
	width: 30rem;
}

.target {
	display: flex;
	align-items: center;
	gap: var(--size-3);
	width: 100%;

	.text {
		flex: 1;
		min-width: 0;
	}

	.sub {
		font-size: var(--text-caption);
		color: var(--color-text-subtle);
	}

	> svg {
		color: var(--color-text-subtle);
		flex-shrink: 0;
	}
}
